<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Movimientos Cuenta Corriente Clientes</div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-text-field
            disabled
            hide-details
            v-model="client.client_name"
            label="Cliente"
          >
            <v-icon
              slot="prepend"
              class="enabled-icon"
              @click="clientSearchClick"
            >
              mdi-magnify
            </v-icon>
            <!-- eslint-disable -->
            <v-icon
              slot="append-outer"
              class="enabled-icon"
              @click="clientSelected(null)"
            >
              mdi-close
            </v-icon>
            <!-- eslint-enable -->
          </v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Comercial"
            :items="commercialPersonItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="commercial_person"
            return-object
            @change="commercialPersonSelected($event)"
            ref="commercialPersonAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('commercialPersonAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-text-field
            label="Antiguedad (ultimos N dias)"
            hide-details
            type="number"
            min="0"
            v-model.number="daysFrom"
            @change="daysFromChanged"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-checkbox
            class="mt-0 pt-0"
            label="No Visualizados"
            hide-details
            v-model="unseenOnly"
            @change="unseenOnlyChanged"
          ></v-checkbox>
          <v-progress-linear
            :active="loading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
      <div v-show="pivotLoaded" id="pivot-container" class="mt-2"></div>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="clientShowSearch"
      :show="clientShowSearch"
      :title="clientSearchOptions.title"
      :endpoint="clientSearchOptions.endpoint"
      :ordering="clientSearchOptions.ordeting"
      :searchLabel="clientSearchOptions.searchLabel"
      :headers="clientSearchOptions.headers"
      :filterString="clientSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="clientSearchOptions.searchOnURL"
      @itemSelected="clientSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.min.css";
import "webdatarocks/webdatarocks.toolbar";
import wdrEs from "@/assets/webDataRocksEs.json";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "ClientCurrentAccountMovements",

  components: {
    PaginatedSearchDialog
  },

  data() {
    return {
      currentLevel: -1,
      clientSearchOptions: {},
      clientShowSearch: false,
      client: {
        client_code: "",
        client_name: "",
        client_id: 0,
        dealers_quantity: 0
      },
      campaign_id: 0,
      daysFrom: 10,
      unseenOnly: false,
      lastViewedParameterUrl: null,
      maxLoadedMovementId: 0,
      pivot: null,
      pivotLoaded: false,
      loading: true,
      commercialPersonItems: [],
      filterCommercialPerson: null
    };
  },

  methods: {
    getRouteParamValue(key) {
      if (this.$route.params[key] !== undefined) {
        return this.$route.params[key];
      }
      return this.$route.query[key];
    },

    getRouteInt(key, defaultValue) {
      const raw = this.getRouteParamValue(key);
      const parsed = parseInt(raw, 10);
      return Number.isNaN(parsed) ? defaultValue : parsed;
    },

    getRouteBool(keys, defaultValue) {
      for (const key of keys) {
        const raw = this.getRouteParamValue(key);
        if (raw === undefined || raw === null || raw === "") {
          continue;
        }
        if (typeof raw === "boolean") {
          return raw;
        }
        const normalized = raw.toString().toLowerCase();
        if (["1", "true", "t", "si", "yes", "y"].includes(normalized)) {
          return true;
        }
        if (["0", "false", "f", "no", "n"].includes(normalized)) {
          return false;
        }
      }
      return defaultValue;
    },

    hasDaysFromValue() {
      return (
        this.daysFrom !== null &&
        this.daysFrom !== undefined &&
        this.daysFrom !== ""
      );
    },

    getCollectionData(raw) {
      if (!raw) {
        return [];
      }
      if (Array.isArray(raw)) {
        return raw;
      }
      if (Array.isArray(raw.results)) {
        return raw.results;
      }
      return [];
    },

    getMaxMovementId(data) {
      const rows = this.getCollectionData(data);
      let maxId = 0;
      for (const row of rows) {
        const parsed = parseInt(row.id, 10);
        if (!Number.isNaN(parsed) && parsed > maxId) {
          maxId = parsed;
        }
      }
      return maxId;
    },

    async getLastViewedStatus() {
      if (!this.lastViewedParameterUrl) {
        const response = await this.$bRoot.search(
          "/user/configuration_parameters"
        );
        const params = response
          ? Array.isArray(response.data)
            ? response.data
            : response.data.results || []
          : [];
        const parameter = params.find(
          item => item.name === "last_viewed_cac_id"
        );
        if (!parameter) {
          return {
            parameterUrl: null,
            currentValue: 0,
            configuration: null
          };
        }
        this.lastViewedParameterUrl = parameter.url;
      }

      const userConfigResponse = await this.$bRoot.search(
        "/user/user_configurations"
      );
      const userConfigs = userConfigResponse
        ? Array.isArray(userConfigResponse.data)
          ? userConfigResponse.data
          : userConfigResponse.data.results || []
        : [];

      const lastViewedConfig = userConfigs.find(
        item =>
          item.parameter === this.lastViewedParameterUrl ||
          item.name === "last_viewed_cac_id"
      );

      const parsed = lastViewedConfig
        ? parseInt(lastViewedConfig.value, 10)
        : 0;

      return {
        parameterUrl: this.lastViewedParameterUrl,
        currentValue: Number.isNaN(parsed) ? 0 : parsed,
        configuration: lastViewedConfig || null
      };
    },

    async syncLastViewedAfterLoad(data) {
      if (!this.unseenOnly) {
        return;
      }

      const maxId = this.getMaxMovementId(data);
      this.maxLoadedMovementId = maxId;
      if (maxId <= 0) {
        return;
      }

      const status = await this.getLastViewedStatus();
      if (!status.parameterUrl || status.currentValue >= maxId) {
        return;
      }

      const newValue = maxId.toString();

      if (status.configuration) {
        const object = { ...status.configuration };
        object.value = newValue;
        await this.$bRoot.save(object);
      } else {
        await this.$bRoot.add("/user/user_configurations", null, {
          value: newValue,
          parameter: status.parameterUrl
        });
      }
    },

    async applyNavigationParams() {
      this.daysFrom = this.getRouteInt("days_from", this.daysFrom);
      this.daysFrom = this.daysFrom < 0 ? 0 : this.daysFrom;
      this.unseenOnly = this.getRouteBool(["unseen_only"], this.unseenOnly);
    },

    //Reading data from API method.
    async readDataFromAPI() {
      try {
        this.loading = true;
        if (this.hasDaysFromValue()) {
          let endpoint =
            "/data/account_receivables_movements/" +
            (this.client ? this.client.client_id.toString() : "0") +
            "/";
          /* eslint-disable */
          switch (this.filterCommercialPerson ? this.filterCommercialPerson.commercial_type_level : 0) {
            case 0:
              endpoint = endpoint + "0/0/0";
              break;
            case 1:
              endpoint = endpoint + this.filterCommercialPerson.commercial_id.toString() + "/0/0";
              break;
            case 2:
              endpoint = endpoint + "0/" + this.filterCommercialPerson.commercial_id.toString() + "/0";
              break;
            case 3:
              endpoint = endpoint + "0/0/" + this.filterCommercialPerson.commercial_id.toString();
              break;
          }
          /* eslint-enable */
          endpoint =
            endpoint +
            "/" +
            this.daysFrom.toString() +
            "/" +
            (this.unseenOnly ? "1" : "0");

          let response = await this.$bRoot.search(endpoint);
          const data = response ? response.data : [];

          let title = "Movimientos cuenta corriente";
          if (this.client.client_id > 0) {
            title +=
              " cliente " +
              (this.client.client_name || this.client.client_id.toString());
          } else if (this.filterCommercialPerson) {
            title +=
              " clientes del comercial " + this.filterCommercialPerson.name;
          }

          await this.loadPivotTable(data, title);
          await this.syncLastViewedAfterLoad(data);
          await this.$bRoot.auth.refreshUnseenAccountReceivableMovements(true);
          this.pivotLoaded = true;
        } else {
          this.pivotLoaded = false;
          this.unloadPivotTable();
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    clientSearchClick() {
      this.clientSearchOptions = {
        headers: [
          { text: "Código", value: "client_data.code", sortable: false },
          {
            text: "Identificación",
            value: "client_data.identification",
            sortable: false
          },
          { text: "Nombre", value: "client_data.name", sortable: false },
          {
            text: "Categoría",
            value: "client_data.category_object.description",
            sorteable: false
          }
        ],
        title: "Cliente...",
        endpoint: "/data/clients_hierarchy/" + this.campaign_id.toString(),
        ordering: null,
        searchLabel: "Código/CUIT/Nombre",
        filterString: null,
        selected: "clientSelected",
        searchOnURL: true
      };
      this.clientShowSearch = true;
    },

    async clientSelected(client) {
      if (client) {
        this.clearAutocomplete("commercialPersonAutocomplete");
        this.client = {
          client_code: client.client_data.code,
          client_name: client.client_data.name,
          client_id: client.client_data.id,
          dealers_quantity: client.dealers_quantity
        };
      } else {
        this.client = {
          client_code: "",
          client_name: "",
          client_id: 0,
          dealers_quantity: 0
        };
      }
      this.searchCanceled();
      await this.readDataFromAPI();
    },

    async commercialPersonSelected(item) {
      await this.clientSelected(null);
      this.filterCommercialPerson = item;
      await this.readDataFromAPI();
    },

    async daysFromChanged() {
      if (
        this.daysFrom === null ||
        this.daysFrom === undefined ||
        this.daysFrom < 0
      ) {
        this.daysFrom = 0;
      }
      await this.readDataFromAPI();
    },

    async unseenOnlyChanged() {
      await this.readDataFromAPI();
    },

    async clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      if (field === "commercialPersonAutocomplete") {
        this.filterCommercialPerson = null;
      }
      await this.readDataFromAPI();
    },

    async searchCanceled() {
      this.clientShowSearch = false;
      this.clientSearchOptions = {};
    },

    async loadPivotTable(data, title) {
      this.pivot = null;
      const pivotData = this.getCollectionData(data).map(item => {
        const movementDate = this.$moment(
          item.comprobante_fecha,
          [
            "DD/MM/YYYY",
            "YYYY-MM-DD",
            "YYYY-MM-DD HH:mm:ss",
            this.$moment.ISO_8601
          ],
          true
        );

        return {
          ...item,
          comprobante_fecha_sort: movementDate.isValid()
            ? movementDate.format("YYYY-MM-DD")
            : "",
          comprobante_fecha: movementDate.isValid()
            ? movementDate.format("DD/MM/YYYY")
            : item.comprobante_fecha
        };
      });
      pivotData.sort((left, right) => {
        const dateDiff = right.comprobante_fecha_sort.localeCompare(
          left.comprobante_fecha_sort
        );
        if (dateDiff !== 0) {
          return dateDiff;
        }
        const rightId = parseInt(right.id, 10);
        const leftId = parseInt(left.id, 10);
        if (Number.isNaN(rightId) || Number.isNaN(leftId)) {
          return 0;
        }
        return rightId - leftId;
      });
      /*Crear Pivot Table*/
      let rows = [
        {
          uniqueName: "comprobante_fecha_sort",
          caption: "fecha",
          sort: "desc"
        },
        { uniqueName: "cliente_codigo", caption: "codigo cliente" },
        { uniqueName: "cliente_nombre", caption: "cliente" },
        { uniqueName: "distribuidor_nombre", caption: "distribuidor" },
        { uniqueName: "comprobante_codigo", caption: "comprobante" },
        { uniqueName: "comprobante_descripcion", caption: "descripcion" },
        { uniqueName: "moneda_codigo", caption: "moneda" }
      ];

      let measures = [
        {
          uniqueName: "Importe",
          caption: "Importe",
          individual: true,
          formula: '"importe"',
          format: "f_importe"
        }
      ];

      const column_definition = {
        comprobante_fecha_sort: { type: "string" },
        cliente_codigo: { type: "string" },
        cliente_nombre: { type: "string" },
        distribuidor_nombre: { type: "string" },
        comprobante_fecha: { type: "string" },
        comprobante_codigo: { type: "string" },
        comprobante_descripcion: { type: "string" },
        moneda_codigo: { type: "string" },
        importe: { type: "number" }
      };
      pivotData.unshift(column_definition);

      this.pivot = new WebDataRocks({
        container: "#pivot-container",
        toolbar: true,
        customizeCell: (cellBuilder, cellData) =>
          this.customizePivotCell(cellBuilder, cellData),
        beforetoolbarcreated: this.customizeToolbar,
        reportcomplete: this.expandsPivotTable,
        global: {
          localization: wdrEs
        },
        report: {
          options: {
            showAggregationLabels: false,
            grid: {
              type: "flat",
              showHeaders: false,
              showTotals: "off",
              showGrandTotals: "off",
              title: title
            },
            configuratorButton: false
          },
          dataSource: {
            data: pivotData
          },
          slice: {
            rows: rows,
            columns: [{ uniqueName: "Measures" }],
            measures: measures,
            expands: {
              expandAll: false
            }
          },
          formats: [
            {
              name: "f_importe",
              thousandsSeparator: ".",
              decimalSeparator: ",",
              decimalPlaces: 2,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_valor",
              thousandsSeparator: ".",
              decimalPlaces: 0,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            }
          ]
        }
      });
    },

    unloadPivotTable() {
      this.pivot = null;
    },

    customizePivotCell(cellBuilder, cellData) {
      if (
        cellData.type !== "header" ||
        !cellData.hierarchy ||
        cellData.hierarchy.uniqueName !== "comprobante_fecha_sort" ||
        !cellData.label
      ) {
        return;
      }

      const movementDate = this.$moment(cellData.label, "YYYY-MM-DD", true);
      if (movementDate.isValid()) {
        cellBuilder.text = movementDate.format("DD/MM/YYYY");
      }
    },

    customizeToolbar(toolbar, sr = this) {
      var tabs = toolbar.getTabs();
      tabs.forEach((tab, index) => {
        if (!(tab.id == "wdr-tab-fullscreen" || tab.id == "wdr-tab-export")) {
          delete tabs[index];
        }
      });
      toolbar.getTabs = function(
        ea = () => {
          sr.expandAllPivotTable();
        }
      ) {
        tabs.unshift({
          id: "wdr-tab-expand-all",
          title: "Expandir",
          icon: '<i class="mdi mdi-24px mdi-expand-all-outline"></i>',
          handler: ea
        });
        return tabs;
      };
    },

    expandsPivotTable() {
      this.pivot.expandData("cliente_nombre");
      this.pivot.expandData("distribuidor_nombre");
    },

    expandAllPivotTable() {
      this.pivot.expandAllData();
    }
  },

  watch: {
    async $route() {
      await this.applyNavigationParams();
      await this.readDataFromAPI();
    }
  },

  async mounted() {
    try {
      var main_container = document.getElementById("app");
      main_container.classList.remove("home");

      this.currentLevel = this.$bRoot.auth.current_level;
      //get campaign
      // eslint-disable-next-line
      let campaigns = await this.$bRoot.searchAll("/data/campaigns", null, "code", "orders_enabled__in=S,D");
      for (let c in campaigns) {
        this.campaign_id = campaigns[c].id;
        break;
      }

      //load commercial persons
      let commercialPersons = await this.$bRoot.searchAll(
        "/data/commercial_persons_hierarchy",
        null,
        "name",
        "commercial_type_level__lt=4"
      );
      this.commercialPersonItems = commercialPersons;

      await this.applyNavigationParams();
      await this.readDataFromAPI();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
.enabled-icon {
  pointer-events: auto;
  color: black;
}
</style>
